










































import Vue from 'vue';
import TaskService from '@/api/task.service';
import { ITask, TaskStatus } from '@/store/types';
import eventBus from '@/helpers/event-bus';

export default Vue.extend({
  name: 'TaskMonitor',
  props: {
    taskId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showTask: false,
      task: null as ITask | null,
      loading: false,
      error: null as any,
      interval: null as any,
    };
  },
  async created() {
    await this.fetchTaskProgress();
    this.loading = false;
  },
  computed: {
    percentage(): number {
      return this.task?.percentage || 0;
    },
    taskItems(): any[] {
      return this.task?.items || [];
    },
    title(): string {
      return this.task?.title || 'Processing Task';
    },
    description(): string {
      return this.task?.description || 'Please wait while this task is being processed';
    },
    blocked(): boolean {
      return (this.task?.blocking && this.task?.status === TaskStatus.RUNNING) || false;
    },
  },
  methods: {
    async fetchTaskProgress() {
      try {
        const response = await TaskService.get(this.taskId);
        if (response && response.status !== TaskStatus.COMPLETED) {
          this.showTask = true;
        } else {
          eventBus.$emit('task-completed', this.taskId, this.task?.taskType);
          // this.showTask = false;
          this.stopPolling();
        }
        this.task = response;
      } catch (error) {
        console.error('Failed to fetch task progress:', error);
        this.error = error;
        this.stopPolling();
      }
    },
    startPolling() {
      this.interval = setInterval(this.fetchTaskProgress, 4000);
    },
    stopPolling() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    close() {
      this.showTask = false;
      this.stopPolling();
      this.$emit('close');
    },
  },
  mounted() {
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
});
